@if (meters) {
  <div>
    @for (formFieldForFrontend of formFieldsForFrontend; track formFieldsForFrontend; let i = $index) {
      <div class="re-mb-45">
        <ng-template #selfie [ngTemplateOutlet]="selfie"
          let-control [ngTemplateOutletContext]="{ $implicit: getMetersFormControl(i) }">
          @if (i > 0) {
            <hr class="re-my-30 md:re-my-45 re-border-t re-border-monochrome-medium-light">
            <bdo-circle-icon-text-small
              data-qa="remove_meter"
              [iconStyle]="'minus'"
              [label]="'meterreadings.actions.removeMeter' | translate: { division: [sparte | verbrauchstyp] }"
              (clickEvent)="removeMeter(i)"
            ></bdo-circle-icon-text-small>
          }
          <div class="re-form-item-container">
            <bdo-input
              [id]="'meterNumber' + i"
              [attr.data-qa_id]="'meterNumber' + i"

              [formControl]="formFieldForFrontend.meterFormControl"
              [isWarning]="formFieldForFrontend.message === CheckMeterResponse.METER_NOT_EXISTS"
              [labelText]="(formFieldForFrontend.message === CheckMeterResponse.METER_NOT_EXISTS ? 'meterreadings.warning.meterNotExist' : 'general.customerData.meternumber') | translate"
              [placeholder]="'general.customerData.meternumber' | translate"
              [tooltipTemplate]="formFieldForFrontend.message === CheckMeterResponse.METER_NOT_EXISTS ? undefined : meterInfo"
              (blur)="trackInvalid(formFieldForFrontend.meterFormControl, 'meterNumber' + i)">
            </bdo-input>
            <ng-template #meterInfo>
              <bdo-meterreading-info [division]="sparte"></bdo-meterreading-info>
            </ng-template>
            <div class="re-text-xs re-mt-15">{{ 'meterreadings.info.hintInfo' | translate }}</div>
            @if (formFieldForFrontend.message === CheckMeterResponse.METER_NOT_EXISTS && sparte === Verbrauchstyp.Strom) {
              <div class="bdo-form__helptext"
                [innerHTML]="'meterreadings.warning.nightStorageHeater' | translate: { contactFormLink: reBaseData.hrefContactForm }"
                (click)="onClickHelp($event)">
              </div>
            }
          </div>
          @if (formFieldForFrontend.readings && formFieldForFrontend.readings.length && (formFieldForFrontend.meterFormControl.valid || formFieldForFrontend.meterFormControl.pending)) {
            <div>
              @for (reading of formFieldForFrontend.readings; track reading; let u = $index) {
                <div animate.enter="bdo-fade" class="re-form-item-container">
                  <bdo-input
                    [id]="'reading' + i + u"
                    [attr.data-qa_id]="'reading' + i + u"
                    [formControl]="reading.readingFormControl"

                    [placeholder]="getPlaceholder(reading)"
                    [tooltipContent]="meterreadingInfoService.getInfo(sparte)"(blur)="trackInvalid(reading.readingFormControl, 'reading' + i + u);"
                    >
                  </bdo-input>
                  <div class="bdo-form__helptext" [innerHTML]="'meterreadings.info.enterLater' | translate">
                  </div>
                </div>
              }
            </div>
          }
          @if (showSmartMeterHint && formFieldForFrontend?.meterCheckResult?.isSmartMeter) {
            <div>
              {{ 'meterreadings.smartmeter.readingInfo' | translate }}
            </div>
          }
          <!-- Optional Contract Cancellation -->
          @if (cancelOptionsShown) {
            <div [formGroup]="control">
              <div class="bold re-text-sm re-mb-20">{{ 'delivery.situation.terminateTitle' | translate: { division: [sparte | verbrauchstyp] } }}</div>
              @if (control.get('contractExisting')?.invalid && control.get('contractExisting')?.touched) {
                <div class="re-mb-20 re-text-error">
                  {{ 'general.action.chooseOption' | translate }}
                </div>
              }
              <div class="re-flex re-items-start re-relative re-mb-15">
                <input [id]="'contractNotExists' + sparte + i" type="radio" [value]="'contractNotExists'" formControlName="contractExisting">
                <label class="re-ml-10" [for]="'contractNotExists' + sparte + i" >
                  <span [innerHTML]="'delivery.situation.noContractExist' | translate"></span>
                </label>
              </div>
              <div class="re-flex re-items-start re-relative re-mb-15">
                <input [id]="'contractExists' + sparte + i" type="radio" [value]="'contractExists'" formControlName="contractExisting">
                <label class="re-ml-10" [for]="'contractExists' + sparte + i" >
                  <span [innerHTML]="'delivery.situation.contractExist' | translate"></span>
                </label>
              </div>
              @if (control.get('contractExisting')?.value === 'contractExists') {
                <div class="re-ml-40">
                  <bdo-checkbox
                    [checked]="control.get('automaticCancelEnabled').value"
                    (change)="onAutomaticCancelChange(control.get('automaticCancelEnabled'))"
                    data-qa="cancel_auto">
            <div [innerHtml]="'delivery.situation.withCancel' | translate:
                              { companyName: reBaseData.companyName, division: [sparte | verbrauchstyp] }">
                    </div>
                  </bdo-checkbox>
                </div>
              }
              @if (control.get('contractExisting').value === 'contractExists' && control.get('automaticCancelEnabled')?.value && control.get('previousSupplier')) {
                <div
                  class="re-mt-20">
                  <bdo-supplier-autosuggest
                    [divisionId]="sparte"
                    [supplierControl]="control.get('previousSupplier')"
                    [supplierIdControl]="control.get('previousSupplierId')"
                    [id]="'supplier_' + sparte + '_' + i"
                  ></bdo-supplier-autosuggest>
                </div>
              }
            </div>
          }
          <!-- End Optional Contract Cancellation -->
        </ng-template>
      </div>
    }
  </div>
}



<hr class="re-my-30 md:re-my-45 re-border-t re-border-monochrome-medium-light">

<bdo-circle-icon-text-small
  data-qa="add_meter"
  [iconStyle]="'plus'"
  [label]="'meterreadings.actions.addMeter' | translate: { division: [sparte | verbrauchstyp] }"
  (clickEvent)="addMeterFormGroup()"
></bdo-circle-icon-text-small>
